import React from "react";
import styled from "@emotion/styled";
import copy from "copy-to-clipboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard } from "@fortawesome/pro-regular-svg-icons";

const Styled = styled.div`
  cursor: pointer;
  display: inline;
  width: fit-content;
  margin-left: 10px;

  svg {
    &:hover {
      box-shadow: 0 10px 20px -5px ${(props) => props.theme.text.secondary};
      transform: scale(1.05);
    }
  }

  svg {
    &:active {
      box-shadow: 0 4px 8px ${(props) => props.theme.text.secondary};
      transform: scale(0.98);
    }
  }
`;

type CopyOptions = Parameters<typeof copy>[1];

export type CopyToClipboardProps = Omit<
  React.HTMLAttributes<HTMLDivElement>,
  "onCopy"
> & {
  text: string;
  onCopy?: (text: string, didCopy: boolean) => void;
  options?: CopyOptions;
};

export default function CopyToClipboard(props: CopyToClipboardProps) {
  const { text, onCopy, children, options, ...divProps } = props;

  const onClick: React.MouseEventHandler<HTMLDivElement> = () => {
    const result = copy(text, options);

    onCopy?.(text, result);
  };

  const inner = children ?? <FontAwesomeIcon icon={faClipboard} />;

  return (
    <Styled title="Copy to Clipboard" {...divProps} onClick={onClick}>
      {inner}
    </Styled>
  );
}
